import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const centralLabQuery = createApi({
  baseQuery,
  reducerPath: "centralLabQueries",
  endpoints: (builder) => ({
    createCentralLab: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.centralLab.create)}`,
        method: "POST",
        body: data,
      }),
    }),
    updateCentralLab: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.centralLab.update)}`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteCentralLab: builder.mutation<any, any>({
      query: ({ study_id, central_lab_id }) => ({
        url: `${formatString(
          endPoints.centralLab.delete,
          {
            key: urlKeys.study_id,
            value: encodeURIComponent(study_id),
          },
          {
            key: urlKeys.central_lab_id,
            value: central_lab_id,
          }
        )}`,
        method: "DELETE",
      }),
    }),
    getCentralLabDetails: builder.mutation<any, any>({
      query: ({ study_id }) => ({
        url: `${formatString(endPoints.centralLab.select, {
          key: urlKeys.study_id,
          value: encodeURIComponent(study_id),
        })}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateCentralLabMutation,
  useUpdateCentralLabMutation,
  useDeleteCentralLabMutation,
  useGetCentralLabDetailsMutation,
} = centralLabQuery;
